module.exports = __webpack_public_path__ + "static/media/ico-calendar.c91b8d50.svg";